import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';


const SubmenuItem = ({ translate, ownprops }) => {
  return (
    <li>
      <a href={"/"+ownprops.value.link}>{ translate(ownprops.value.name) }</a>
    </li>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    ownprops: ownProps
  };
};

export default connect(mapStateToProps)(SubmenuItem);



// WEBPACK FOOTER //
// ./src/components/menu/submenu-item.jsx